// latest: zhangmyh 2017-8-14 10:21 AM
const pagemanager = {
  // 采购商ID目前固定为978
  PURCHASEID: window.global.user.PURCHASEID,
  pageType: 'doc',
  editable: false,
  inPRC: true,
  isSelf: false,
  state: -1,
  buttonStyle: -1,
  referconfig: {},
  model: null,
  viewmodel: null,
  init (config) {
    this.id = (config.id) ? parseInt(config.id) : 0
    this.editable = (config.editable == 'true')
    this.pageType = (config.pageType) ? config.pageType : 'doc'
    this.state = (!config.state || config.state < 0) ? -1 : parseInt(config.state)
    if (config.from == 'supply') {
      this.isSelf = true
    }
    this.model = config.model
  },
  async pageInit () {

  }
}

export default pagemanager



// WEBPACK FOOTER //
// ./src/pages/home_noticeview/manager_page.js